export enum PositionType {
    Origin,
    Destination,
    Waypoint
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/positionType.ts